import { hookReduxCreator } from "./hook-creator";

const useStockSnapshot = /** @type { ReturnType<typeof hookReduxCreator<import('../actions/realtimeAction').SnapshotData>} */ (hookReduxCreator(state => state.realtime.snapshot, 'useStockSnapshot'));

export default useStockSnapshot;